import { Component } from '@angular/core';

import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';

@Component({
    selector: 'app-payment-invoice',
    templateUrl: './payment-invoice.component.html',
    styleUrls: ['./payment-invoice.component.scss'],
    standalone: false
})
export class PaymentInvoiceComponent extends BaseFormPageComponent {
  pageVocabs = 'pages.newPayment.invoice.';
  readonly href = 'javascript:window.print()';

  initForm(): void {
    throw new Error('Method not implemented.');
  }
  baseCreateApi(model: any): void {
    throw new Error('Method not implemented.');
  }
  baseUpdateApi(model: any): void {
    throw new Error('Method not implemented.');
  }

  onPrint() {
    window.print();
  }
}
